import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

// Read-only: no creating MOs from a product (an MO needs a specific batch + SKU picked).
const ProductDetailManufacturingOrders=({parentId,application,userData,parent})=>{
    const list_name='product_manufacturing_orders';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'ManufacturingOrder'}
                entityParams={['product_id='+parentId,'_context='+['parent_name=Product'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                file={'ProductDetailManufacturingOrders.js'}
                navigateOnNew={null}
                canCreateNew={false}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default ProductDetailManufacturingOrders;
